import Firebase from 'firebase/app'
import 'firebase/auth'

export const firebaseConfig = Firebase.initializeApp({
    apiKey: "AIzaSyA5JFOurheNgq5qQddoGwc9Ar0qD6qMCAs",
    authDomain: "chat-app-a1cc4.firebaseapp.com",
    projectId: "chat-app-a1cc4",
    storageBucket: "chat-app-a1cc4.appspot.com",
    messagingSenderId: "240126944131",
    appId: "1:240126944131:web:e635a79e9063bf45864cb6",
    databaseURL: "https://chat-app-a1cc4-default-rtdb.asia-southeast1.firebasedatabase.app"
})

// export const firestore = firebaseConfig.firestore()

// export firebaseConfig;